<template>
  <project-tracker :project='project'></project-tracker>
</template>

<script>
import ProjectTracker from '@/components/trackers/ProjectTracker';

export default {
  name: 'snow-action-tracker',
  props: {
    project: {
      required: true
    }
  },
  components: {
    'project-tracker': ProjectTracker
  }
}
</script>
